import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { inject, observer } from 'mobx-react'

import Login from '../Login'
import MainMenu from '../MainMenu'

import './sidebar.scss'

@observer
class Sidebar extends Component {
  render() {
    return (
      <div className="sidebar-wrapper">
        <div className="company-logo">
          <Link to="/order"><img src="/images/logo.png" alt="Elit-Taxi - Online order"/></Link>
        </div>
        <div>
          { this.props.isLoggedIn ? <MainMenu /> : <Login />}
        </div>
      </div>
    )
  }
}

const withData = inject(stores => ({
  isLoggedIn: stores.LoginFromStore.isLoggedIn,
}))

export default withData(Sidebar);
